import { ExplanationFormSchema } from '../schema/explanationFormSchema'

export const explanationFormDefaultValues: Partial<ExplanationFormSchema> = {
  docSetUids: [],
  members: [],
  representative: 'without',
}
